export function nullIfEmpty (s) {
  return s == null ? null : (s === '' ? null : s)
}
export function nullIfBlank (s) {
  return s == null ? null : (s.trim() === '' ? null : s)
}

export function firstNonEmpty (...s) {
  return s.find(e => nullIfEmpty(e) != null)
}

export function firstNonBlank (...s) {
  return s.find(e => nullIfBlank(e) != null)
}

export function reactiveRemove (array, predicate) {
  const removed = []
  while (true) {
    const idx = array.findIndex(predicate)
    if (idx === -1) {
      break
    }
    removed.push(...array.splice(idx, 1))
  }
  return removed
}



// WEBPACK FOOTER //
// ./src/utils/arrays.js